<template>
<div style="margin-top: 64px;">
    <NavBar_MTB/>
    <div>
        <router-view :key="$route.fullPath" 
            @toggle-websocket="propagateWebSocketEmit" :websocket="websocket">
        </router-view>
    </div>
</div>
</template>
<script setup lang="js">
import NavBar_MTB from '@/components/navbars/NavBar_MTB.vue';

/**
 * @prop websocket - A websocket that can be passed down from App.vue. If no websocket connection exists, it is null.
 */
const props = defineProps({
    websocket: WebSocket|null,
})

/**
 * @emit toggle-websocket - Toggles a websocket connection on or off (requires WS prop to be passed).
 */
const emit = defineEmits(['toggle-websocket'])

/**
 * Propagates a websocket toggle from the router-view to the parent component (likely App.vue).
 * @param {Object} emit_params - Emit data about the websocket
 */
const propagateWebSocketEmit = (emit_params) => {
    emit('toggle-websocket', emit_params);
}
</script>

